import type {
  ServiceRequestApiMultiResponseInterface,
  ServiceRequestApiSingleResponseInterface,
  ServiceRequestServiceInterface,
} from '@src/server';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import type {
  AzureSubscriptionContextModuleInterface,
  ServiceRequestInterface,
} from '@src/domain/types';

import { ServiceRequestPostRequest, ServiceRequestsApi } from 'cmp-client-api';

export class ServiceRequestService implements ServiceRequestServiceInterface {
  private readonly service: ServiceRequestsApi;

  private readonly azureContextMapper: MapperInterface<
    AzureSubscriptionContextModuleInterface,
    ServiceRequestPostRequest
  >;

  public constructor(
    service: ServiceRequestsApi,
    serviceMapper: MapperInterface<
      AzureSubscriptionContextModuleInterface,
      ServiceRequestPostRequest
    >
  ) {
    this.service = service;
    this.azureContextMapper = serviceMapper;
  }

  public getRequests(after: string): Promise<ServiceRequestApiMultiResponseInterface> {
    return this.service.getServiceRequests('5', after).then(({ data }) => ({
      ...data,
      data: data.data.map((item) => ({
        ...item,
        supportSystem: item.serviceNow,
      })),
    }));
  }

  public postRequests(
    body: AzureSubscriptionContextModuleInterface
  ): Promise<ServiceRequestInterface> {
    return this.service
      .createServiceRequest(undefined, this.azureContextMapper.transformToApiModel(body))
      .then(({ data }) => data)
      .then(({ data }) => ({ ...data, supportSystem: data.serviceNow }));
  }

  public getRequest(servicerecordId: string): Promise<ServiceRequestInterface> {
    return this.service
      .getServiceRequest(servicerecordId)
      .then(
        ({ data }): ServiceRequestApiSingleResponseInterface => ({
          data: {
            ...data.data,
            supportSystem: data.data.serviceNow,
          },
        })
      )
      .then(({ data }) => data);
  }
}
